import { ArrowBack } from '@mui/icons-material';
import { AppBar, IconButton, Skeleton, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UserWidget } from 'features/auth';
import { useNavigate } from 'react-router-dom';

import { MobileHeaderConfig } from '../../../contexts/NavigationContext';
import Spacer from '../Spacer';

interface DetailPageHeaderProps {
    config: MobileHeaderConfig;
}

export default function DetailPageHeader({ config }: DetailPageHeaderProps) {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(config.backUrl);
    };

    return (
        <>
            <AppBar position="fixed"
                color="default">
                <HeaderContent>
                    <BackButton onClick={ handleBack }
                        aria-label="back"
                        edge="start"
                    >
                        <ArrowBack />
                    </BackButton>

                    { config.isLoading ? (
                        <Skeleton width={ 100 } />
                    ) : (
                        <PageTitle variant="h6"
                            noWrap>
                            { config.title }
                        </PageTitle>
                    ) }

                    { config.showUserWidget && (
                        <UserWidget />
                    ) }
                </HeaderContent>
            </AppBar>

            <Spacer />
        </>
    );
}

const HeaderContent = styled(Toolbar)(({
    display: 'flex',
    alignItems: 'center'
}));

const BackButton = styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(2, 4)
}));

const PageTitle = styled(Typography)({
    flex: 1
});
